<template>
  <div class="button-comp">
    <button
      :data-toggle="dataToggle"
      :data-target="dataTarget"
      class="btn btn--sm btn--text btn--flex"
      :class="classes"
      v-if="!hideButton"
      @click="onClick"
      :disabled="disabled"
      :data-dismiss="dataDismiss"
      :type="buttonType"
    >
      <slot></slot>
      <div class="btn--text">{{ buttonName }}</div>
    </button>
  </div>
</template>
<script>
export default {
  name: "Button",
  props: {
    hideButton: Boolean,
    onClick: {
      type: Function,
      default: () => {},
    },
    buttonName: String,
    disabled: Boolean,
    classes: String,
    dataToggle: String,
    dataDismiss: String,
    buttonType: String,
    dataTarget: String,
  },
};
</script>
<style lang="scss" scoped>
.normal-btn,
.outline-btn {
  width: 105.23px;
  height: 50px;
  background: #e00b5b;
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #ffffff !important;
  }
}
.outline-btn {
  background: #fff;
  border-color: #e00b5b !important;

  .btn--text {
    color: #e00b5b !important;
  }
}

.woven-color {
  background: #e00b5b;
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;

  svg {
    margin-right: 10px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #e00b5b;
  }
}

.basic-woven {
  background: #fff;

  svg {
    margin-right: 10px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #e00b5b;
  }
}
.basic {
  background: #fff;
  border: 1px solid #e00b5b;

  svg {
    margin-right: 10px;
  }
}

.blank {
  background: #fff;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.1px;
    color: #000;
  }
}

.basic-borderless {
  background: #fff;
}

.text {
  background: #fff;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    margin-left: 5px;
    line-height: 18px;
    letter-spacing: 0.1px;
    color: #121212;
  }
}

.basic-borderless {
  background: #fff;
}

.pending {
  background: rgba(255, 154, 2, 0.18);
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #ff9a02;
  }
}

.failed {
  background: rgba(243, 107, 127, 0.16);
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #f36b7f;
  }
}

.cancelled {
  background: rgba(196, 196, 196, 0.16);
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #121212;
  }
}

.danger {
  background: #b1524d;
  border-radius: 4px;
  .btn--text {
    color: #fff;
  }
}

.completed,
.settled {
  background: rgba(96, 205, 167, 0.18);
  border-radius: 4px;

  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #e00b5b;
  }
}

.primary {
  background: #e00b5b;
  border-radius: 4px;

  .btn--text {
    color: #fff;
  }
}
</style>
